
import React from 'react';
import { useLocation } from 'react-router-dom';
import { HeaderBackground } from './HeaderBackground';
import { HeaderLogo } from './HeaderLogo';
import { HeaderTitle } from './HeaderTitle';
import { RegistrationButton } from './RegistrationButton';
import { useIsMobile } from '@/hooks/use-mobile';

const Header = () => {
  const location = useLocation();
  const isMobile = useIsMobile();
  
  const isInRegistrationProcess = location.hash === '#registration-form' || 
                                 new URLSearchParams(location.search).has('registering');

  return (
    <header className="bg-gradient-to-r from-indigo-900 via-purple-800 to-blue-700 text-white py-4 md:py-6 shadow-xl relative overflow-hidden">
      <HeaderBackground />
      
      <div className="container mx-auto px-3 md:px-4 relative z-10">
        {isMobile ? (
          // Mobile layout - stacked vertical design
          <div className="flex flex-col items-center justify-center gap-3">
            <HeaderLogo />
            <HeaderTitle />
            <RegistrationButton isInRegistrationProcess={isInRegistrationProcess} />
          </div>
        ) : (
          // Desktop layout - redesigned horizontal layout
          <div className="flex flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-6">
              <HeaderLogo />
              <HeaderTitle />
            </div>
            <RegistrationButton isInRegistrationProcess={isInRegistrationProcess} />
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
